export default () => ({
  component: 'coupon-payment-type-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
